import React from 'react';

/**
 * Verifica se o valor é um objeto, excluindo arrays e null.
 * @param value Valor a ser verificado
 * @returns Verdadeiro se o valor for um objeto, falso caso contrário
 */
export function matchIsObject(value: unknown): value is object {
  return typeof value === 'object' && !Array.isArray(value) && value !== null;
}

/**
 * Associa uma referência de elemento a uma referência de propriedade, seja ela uma função ou um objeto com a propriedade 'current'.
 * @param ref Referência do elemento a ser associada
 * @param propRef Referência de propriedade, que pode ser uma função ou um objeto com a propriedade 'current'
 */
export function assocRefToPropRef<T extends Element | null>(
  ref: T,
  propRef: React.Ref<T> | undefined
): void {
  if (typeof propRef === 'function') {
    propRef(ref);
  } else if (propRef && matchIsObject(propRef) && 'current' in propRef) {
    propRef.current = ref;
  }
}
